import { render, staticRenderFns } from "./balanceRecharge.vue?vue&type=template&id=35865022&"
import script from "./balanceRecharge.vue?vue&type=script&lang=js&"
export * from "./balanceRecharge.vue?vue&type=script&lang=js&"
import style0 from "./balanceRecharge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports